import { useQuery } from "@tanstack/react-query";

import { createActivationApi } from "app/pages/activation/services/api";
import type { ShortActivationSetSchema } from "app/pages/activation/types/api";

export const SHORT_ACTIVATION_OBJECTS_QUERY_KEY = "activation-objects-short";

const INITIAL_DATA: ShortActivationSetSchema[] = [];

export const useShortActivationSetListQuery = (
    customSelect?: (data: ShortActivationSetSchema[]) => ShortActivationSetSchema[],
    enabled = true,
) => {
    return useQuery({
        enabled,
        queryKey: [SHORT_ACTIVATION_OBJECTS_QUERY_KEY],
        queryFn: async () => {
            const api = createActivationApi();

            return await api.activation.getShortActivations();
        },
        throwOnError: true,
        placeholderData: (previousData) => previousData || INITIAL_DATA,
        select: (data: ShortActivationSetSchema[]) => (customSelect ? customSelect(data) : data),
        refetchOnMount: true,
    });
};
